import { ShieldCheck, Network, Building, FileSignature, ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";

const POINTS = [
  { icon: ShieldCheck, text: "UGC / AICTE regulatory framework guidance" },
  { icon: Building, text: "Campus infrastructure & governance advisory" },
  { icon: Network, text: "Twinning, articulation & exchange arrangements" },
  { icon: FileSignature, text: "Joint and dual degree partnership design" },
];

const IMG =
  "https://images.pexels.com/photos/39234946/pexels-photo-39234946.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export const Advisory = ({ onEnquire }) => (
  <section id="advisory" data-testid="advisory-section" className="py-20 lg:py-28 bg-[#0B192C] text-white">
    <div className="max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-2 gap-14 items-center">
      <Reveal>
        <p className="text-xs sm:text-sm font-semibold uppercase tracking-[0.18em] text-amber-400">03 — For Universities &amp; Institutions</p>
        <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight mt-3 leading-[1.05]">
          Establish your presence in India — with governance that <em className="italic text-amber-400">holds.</em>
        </h2>
        <p className="text-slate-300 text-base sm:text-lg leading-relaxed mt-5">
          We advise international universities and higher-education institutions on setting up on-site campuses in
          India, structuring compliant partnerships, and building twinning arrangements that endure regulatory and
          academic scrutiny.
        </p>
        <ul className="mt-8 divide-y divide-white/10 border-y border-white/10">
          {POINTS.map((p) => (
            <li key={p.text} className="flex items-center gap-4 py-4 group">
              <span className="w-9 h-9 rounded-lg bg-white/10 border border-white/15 flex items-center justify-center shrink-0 group-hover:bg-amber-600/20 transition-colors">
                <p.icon className="w-5 h-5 text-amber-400" />
              </span>
              <span className="text-sm sm:text-base text-slate-200">{p.text}</span>
            </li>
          ))}
        </ul>
        <button data-testid="advisory-enquire-btn"
          onClick={() => onEnquire({ service: "Institutional Setup in India", destination: "Not applicable" })}
          className="group mt-9 inline-flex items-center gap-2 rounded-full bg-amber-600 text-white font-semibold px-7 py-3.5 hover:bg-amber-500 transition-colors duration-300">
          Request Institutional Briefing <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" />
        </button>
      </Reveal>
      <Reveal delay={0.15}>
        <div className="rounded-2xl overflow-hidden border border-white/15 shadow-2xl aspect-[4/5] lg:aspect-auto lg:h-[560px]">
          <img src={IMG} alt="Historic university library — institutional partnership" className="w-full h-full object-cover" />
        </div>
      </Reveal>
    </div>
  </section>
);
